import CorporateCourseMenuRedirectMiddleware from '@/middleware/CorporateCourseMenuRedirectMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/notes',
        name: 'notes-home',
        component: () => import('@/pages/notes/NotesHome.vue'),
        meta: {
            title: 'My Notes',
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view', subject: 'note' },
        },
    },
    {
        path: '/courses/:courseId/notes',
        name: 'course-notes',
        component: () => import('@/pages/courses/notes/Notes.vue'),
        beforeEnter: CorporateCourseMenuRedirectMiddleware,
        meta: {
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: { action: 'edit', subject: 'note' },
        },
        props: true,
    },
];
